$(window).on("load", function () {
  $("#preloader").delay(1e3).fadeOut("slow");
}), $(document).ready(function () {
  $(".pictureChanger img.mainImgAlt").hide();

  $(".pictureChanger").hover(
    function () {
      $(this).find("img.mainImg").hide();
      $(this).find("img.mainImgAlt").show();
    },
    function () {
      $(this).find("img.mainImg").show();
      $(this).find("img.mainImgAlt").hide();
    }
  );

  $(".popup-gallery").magnificPopup({
    delegate: "a",
    type: "image",
    tLoading: "Loading image #%curr%...",
    preloader: true,
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [4, 4], // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: '',
    },
  });

  // $("body").on("mouseenter", ".pictureChanger", function (e) {
  //   $(this+' img.mainImg').hide();
  //   $(this+' img.mainImgAlt').show();
  // });

  // $("body").on("mouseleave", ".pictureChanger", function (e) {
  //   $(this+' img.mainImg').show();
  //   $(this+' img.mainImgAlt').hide();
  // });
});


  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[title="Tasting Options"]').forEach(function (link) {
      link.setAttribute("target", "_blank");
    });
  });

(function ($, window) {
  'use strict';

  var popupAutoCloseTimer = null;

  var CardAddManager = {
    instances: [],
    lastCart: null,
    init: function () {
      var $wrappers = $('.js-card-add-wrapper');
      if (!$wrappers.length) {
        return;
      }

      var self = this;
      this.instances = [];
      $wrappers.each(function () {
        self.instances.push(new CardAddInstance($(this), self));
      });

      if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function') {
        ShopifyAPI.getCart(function (cart) {
          self.handleCartUpdate(cart);
        });
      }
    },
    handleCartUpdate: function (cart) {
      this.lastCart = cart || null;
      this.instances.forEach(function (instance) {
        instance.syncFromCart(cart);
      });
    },
    requestCartSync: function () {
      var self = this;
      if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
        ajaxCart.load();
      } else if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function') {
        ShopifyAPI.getCart(function (cart) {
          self.handleCartUpdate(cart);
        });
      }
    },
    notifyError: function (message) {
      if (!message) {
        return;
      }
      var $errorPopup = $('.error-popup');
      if ($errorPopup.length) {
        $errorPopup.find('.error-message').text(message);
        if (typeof showPopup === 'function') {
          showPopup('.error-popup');
        }
      } else {
        window.alert(message);
      }
    }
  };

  function CardAddInstance($wrapper, manager) {
    this.$wrapper = $wrapper;
    this.manager = manager;
    this.$form = $wrapper.closest('form');
    this.$button = $wrapper.find('.js-card-add-to-bag');
    this.$controller = $wrapper.find('.js-card-qty-controller');
    this.$qtyLabel = $wrapper.find('.js-card-qty-value');
    this.$minus = $wrapper.find('.js-card-qty-minus');
    this.$plus = $wrapper.find('.js-card-qty-plus');
    this.$variantSelect = this.$form.find('select[name="id"]');
    this.defaultVariantId = parseInt($wrapper.data('defaultVariant'), 10) || null;
    this.currentVariantId = this.getInitialVariantId();
    this.currentQty = 0;
    this.isBusy = false;
    this.busyContext = null;
    this.variantIndex = this.buildVariantIndex();
    this.loadingTarget = null;

    this.bindEvents();
    this.render();
  }

  CardAddInstance.prototype.buildVariantIndex = function () {
    var raw = this.$wrapper.attr('data-variants');
    if (!raw) {
      return {};
    }
    var parsed = [];
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      parsed = [];
    }
    var map = {};
    parsed.forEach(function (variant) {
      map[variant.id] = variant;
    });
    return map;
  };

  CardAddInstance.prototype.getInitialVariantId = function () {
    if (this.$variantSelect.length) {
      var val = parseInt(this.$variantSelect.val(), 10);
      if (!isNaN(val)) {
        return val;
      }
    }
    return this.defaultVariantId;
  };

  CardAddInstance.prototype.bindEvents = function () {
    var self = this;

    this.$button.on('click', function (evt) {
      evt.preventDefault();
      self.adjustQuantity(1, self.$button);
    });

    if (this.$variantSelect.length) {
      this.$variantSelect.on('change', function () {
        var variantId = parseInt($(this).val(), 10);
        if (!isNaN(variantId)) {
          self.currentVariantId = variantId;
          if (self.manager.lastCart) {
            self.syncFromCart(self.manager.lastCart);
          } else {
            self.currentQty = 0;
            self.render();
          }
        }
      });
    }

    this.$plus.on('click', function (evt) {
      evt.preventDefault();
      self.adjustQuantity(1, $(this));
    });

    this.$minus.on('click', function (evt) {
      evt.preventDefault();
      self.adjustQuantity(-1, $(this));
    });
  };

  CardAddInstance.prototype.syncFromCart = function (cart) {
    if (!cart || !this.currentVariantId) {
      this.currentQty = 0;
      this.render();
      return;
    }
    var item = this.findCartItem(cart, this.currentVariantId);
    this.currentQty = item ? item.quantity : 0;
    this.render();
  };

  CardAddInstance.prototype.render = function () {
    if (this.currentQty > 0) {
      this.$button.addClass('is-hidden');
      this.$controller.addClass('is-visible').attr('data-qty', this.currentQty);
    } else {
      this.$button.removeClass('is-hidden');
      this.$controller.removeClass('is-visible').attr('data-qty', 0);
    }
    var disableControls = this.isBusy;
    var disableMinus = this.currentQty <= 0 || disableControls;
    this.$qtyLabel.text(this.currentQty);
    this.$minus.prop('disabled', disableMinus);
    this.$plus.prop('disabled', disableControls);
    this.$button.prop('disabled', disableControls);
  };

CardAddInstance.prototype.setBusy = function (state, context) {
  this.isBusy = state;
  this.busyContext = state ? (context || null) : null;
  this.$wrapper.toggleClass('is-busy', state);
  this.render();
  };

  CardAddInstance.prototype.startLoading = function ($target) {
    this.stopLoading();
    if ($target && $target.length) {
      this.loadingTarget = $target;
      $target.addClass('is-loading');
    }
  };

  CardAddInstance.prototype.stopLoading = function () {
    if (this.loadingTarget && this.loadingTarget.length) {
      this.loadingTarget.removeClass('is-loading');
    }
    this.loadingTarget = null;
  };

  CardAddInstance.prototype.getActionContext = function ($trigger, fallback) {
    if ($trigger && $trigger.hasClass('card-qty-btn')) {
      return 'controller';
    }
    return fallback || 'add';
  };

  CardAddInstance.prototype.adjustQuantity = function (delta, $trigger) {
    if (this.isBusy || !this.currentVariantId) {
      return;
    }
    if (delta > 0) {
      this.addOne($trigger);
    } else if (this.currentQty > 0) {
      var target = Math.max(0, this.currentQty - 1);
      this.setQuantity(target, $trigger);
    }
  };

  CardAddInstance.prototype.addOne = function ($trigger) {
    var self = this;
    var context = this.getActionContext($trigger, 'add');
    var $target = $trigger && $trigger.length ? $trigger : this.$button;
    this.setBusy(true, context);
    this.startLoading($target);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: this.currentVariantId,
        quantity: 1
      },
      success: function (item) {
        self.handleAddSuccess(item);
      },
      error: function (xhr) {
        self.handleError(xhr);
      },
      complete: function () {
        self.stopLoading();
        self.setBusy(false);
      }
    });
  };

  CardAddInstance.prototype.setQuantity = function (targetQty, $trigger) {
    var self = this;
    var context = this.getActionContext($trigger, 'controller');
    var $target = $trigger && $trigger.length ? $trigger : this.$controller;
    this.setBusy(true, context);
    this.startLoading($target);
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: this.currentVariantId,
        quantity: targetQty
      },
      success: function (cart) {
        self.handleChangeSuccess(cart);
      },
      error: function (xhr) {
        self.handleError(xhr);
      },
      complete: function () {
        self.stopLoading();
        self.setBusy(false);
      }
    });
  };

  CardAddInstance.prototype.handleAddSuccess = function (item) {
    var lineQty = item && item.quantity ? item.quantity : (this.currentQty + 1);
    this.currentQty = lineQty;
    this.render();
    this.showPopup({
      title: item && item.title ? item.title : this.$wrapper.data('productTitle'),
      price: item && item.price ? item.price : this.getVariantPrice(),
      quantity: this.currentQty,
      linePrice: item && item.line_price ? item.line_price : this.getVariantPrice() * this.currentQty,
      image: item && item.image ? item.image : this.getVariantImage()
    });
    this.manager.requestCartSync();
  };

  CardAddInstance.prototype.handleChangeSuccess = function (cart) {
    this.manager.handleCartUpdate(cart);
    var item = this.findCartItem(cart, this.currentVariantId);
    var quantity = item ? item.quantity : 0;
    this.currentQty = quantity;
    this.render();
    this.showPopup({
      title: item ? item.product_title : this.$wrapper.data('productTitle'),
      price: item ? item.price : this.getVariantPrice(),
      quantity: quantity,
      linePrice: item ? item.line_price : this.getVariantPrice() * quantity,
      image: item && item.image ? item.image : this.getVariantImage(),
      itemCount: cart ? cart.item_count : null,
      cartTotal: cart ? cart.total_price : null
    });
    this.manager.requestCartSync();
  };

  CardAddInstance.prototype.handleError = function (xhr) {
    var message;
    if (xhr && xhr.responseJSON && xhr.responseJSON.description) {
      message = xhr.responseJSON.description;
    } else if (xhr && xhr.responseText) {
      try {
        var data = JSON.parse(xhr.responseText);
        message = data.description || data.message;
      } catch (e) {
        message = null;
      }
    }
    this.manager.notifyError(message || 'Unable to update cart. Please try again.');
  };

  CardAddInstance.prototype.findCartItem = function (cart, variantId) {
    if (!cart || !cart.items) {
      return null;
    }
    for (var i = 0; i < cart.items.length; i += 1) {
      if (cart.items[i].variant_id === variantId) {
        return cart.items[i];
      }
    }
    return null;
  };

  CardAddInstance.prototype.getVariantData = function () {
    if (this.variantIndex && this.currentVariantId && this.variantIndex[this.currentVariantId]) {
      return this.variantIndex[this.currentVariantId];
    }
    return null;
  };

  CardAddInstance.prototype.getVariantPrice = function () {
    var variant = this.getVariantData();
    if (variant && typeof variant.price !== 'undefined') {
      return variant.price;
    }
    var fallback = parseInt(this.$wrapper.attr('data-product-price'), 10);
    return isNaN(fallback) ? 0 : fallback;
  };

  CardAddInstance.prototype.getVariantImage = function () {
    var variant = this.getVariantData();
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    return this.$wrapper.attr('data-product-image') || '';
  };

  CardAddInstance.prototype.formatMoney = function (value) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(value, window.money_format);
    }
    return value;
  };

  CardAddInstance.prototype.showPopup = function (payload) {
    var $popup = $('.product-popup');
    if (!$popup.length || typeof showPopup !== 'function') {
      return;
    }
    if (payload.title) {
      $popup.find('.product-name').text(payload.title);
    }
    if (typeof payload.price !== 'undefined') {
      $popup.find('.product-price').html(this.formatMoney(payload.price));
    }
    if (typeof payload.quantity !== 'undefined') {
      $popup.find('.product-qty').text(payload.quantity);
    }
    if (typeof payload.linePrice !== 'undefined') {
      $popup.find('.product-total').html(this.formatMoney(payload.linePrice));
    }
    if (payload.image) {
      $popup.find('.product-image img').attr('src', payload.image);
    }
    if (typeof payload.itemCount !== 'undefined' && payload.itemCount !== null) {
      $popup.find('.product-item-count').text(payload.itemCount);
    }
    if (typeof payload.cartTotal !== 'undefined' && payload.cartTotal !== null) {
      $popup.find('.product-total-cart').html(this.formatMoney(payload.cartTotal));
    }
    showPopup('.product-popup');
    if (popupAutoCloseTimer) {
      clearTimeout(popupAutoCloseTimer);
    }
    popupAutoCloseTimer = setTimeout(function () {
      if (typeof hidePopup === 'function') {
        hidePopup('.product-popup');
      } else {
        $('.product-popup').removeClass('active');
      }
    }, 2900);
  };

  window.CardAddToBag = {
    init: function () {
      CardAddManager.init();
    },
    handleCartUpdate: function (cart) {
      CardAddManager.handleCartUpdate(cart);
    }
  };

  function updateHeaderCartCount(cart) {
    var $headerCount = $('.js-number-cart');
    if ($headerCount.length && cart) {
      var itemCount = cart.item_count || 0;
      if (itemCount > 0) {
        $headerCount.text(itemCount).addClass('active');
      } else {
        $headerCount.text('').removeClass('active');
      }
    }
  }

  $(document).ready(function () {
    window.CardAddToBag.init();
    $(document.body).on('ajaxCart.afterCartLoad', function (evt, cart) {
      updateHeaderCartCount(cart);
      if (window.CardAddToBag && typeof window.CardAddToBag.handleCartUpdate === 'function') {
        window.CardAddToBag.handleCartUpdate(cart);
      }
    });
    
    // Also update on initial page load
    if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function') {
      ShopifyAPI.getCart(function (cart) {
        updateHeaderCartCount(cart);
      });
    }
  });
})(jQuery, window);

